export default {
  getAdmin({ state, dispatch, rootState, commit }) {
    var promesas = [];
    rootState.app.arrayTiempoReal.forEach(f => {
      f();
    })
    commit('app/resetTiempoReal', {}, { root: true })
    state.cargasArrayAdmin.forEach(p => {
      p.loading = true;
      promesas.push(
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      )
    });
    return Promise.all(promesas)
  },
  getNegocio({ state, dispatch, commit, rootState }) {
    rootState.app.arrayTiempoReal.forEach(f => {
      f();
    })
    commit('app/setLoadingNegocioGest', true, { root: true })
    commit('app/resetTiempoReal', {}, { root: true })
    commit('restaurantes/resetRestaurantes', {}, { root: true });
    commit('productos/resetProductos', {}, { root: true });
    commit('categorias/resetCategorias', {}, { root: true });
    commit('totems/resetTotems', {}, { root: true });
    commit('neo/resetDatosNeo', {}, { root: true });
    var promesas = [];
    state.cargasArrayNegocio.forEach(p => {
      p.loading = true;
      if (!p.lazy) {
        promesas.push(
          dispatch(p.accion, '', { root: true })
            .finally(() => { p.loading = false })
        )
      } else {
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      }
    });
    return Promise.all(promesas).finally(() => { commit('app/setLoadingNegocioGest', false, { root: true }) })
  },
  async getDirectorio({ state, dispatch, commit, rootState }) {
    rootState.app.arrayTiempoReal.forEach(f => {
      f();
    })
    commit('app/setLoadingNegocioGest', true, { root: true })
    commit('app/resetTiempoReal', {}, { root: true })
    commit('restaurantes/resetRestaurantes', {}, { root: true });
    commit('productos/resetProductos', {}, { root: true });
    commit('categorias/resetCategorias', {}, { root: true });
    commit('totems/resetTotems', {}, { root: true });
    commit('neo/resetDatosNeo', {}, { root: true });

    await dispatch('directorios/getDirectorioGest', '', { root: true })
    var promesas = [];
    state.cargasArrayDirectorio.forEach(p => {
      p.loading = true;
      if (!p.lazy) {
        promesas.push(
          dispatch(p.accion, '', { root: true })
            .finally(() => { p.loading = false })
        )
      } else {
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      }
    });
    return Promise.all(promesas).finally(() => { commit('app/setLoadingNegocioGest', false, { root: true }) })
  },
  getBossRestaurante({ state, dispatch, rootState, commit }) {
    rootState.app.arrayTiempoReal.forEach(f => {
      f();
    })
    commit('app/resetTiempoReal', {}, { root: true })
    var promesas = [];
    state.cargasArrayBossRestaurante.forEach(p => {
      p.loading = true;
      promesas.push(
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      )
    });
    return Promise.all(promesas)
  },
  getBossNegocio({ state, dispatch }) {
    var promesas = [];
    state.cargasArrayBossNegocio.forEach(p => {
      p.loading = true;
      promesas.push(
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      )
    });
    return Promise.all(promesas)
  },
  async getBossDirectorio({ state, dispatch }) {
    var promesas = [];
    await dispatch('directorios/getDirectorioGest', '', { root: true })

    state.cargasArrayBossDirectorio.forEach(p => {
      p.loading = true;
      promesas.push(
        dispatch(p.accion, '', { root: true })
          .finally(() => { p.loading = false })
      )
    });
    return Promise.all(promesas)
  },
}